import { render, staticRenderFns } from "./TabelaDinamicaDashboardLaudos.vue?vue&type=template&id=4efdd42a&scoped=true&lang=pug"
import script from "./TabelaDinamicaDashboardLaudos.vue?vue&type=script&lang=js"
export * from "./TabelaDinamicaDashboardLaudos.vue?vue&type=script&lang=js"
import style0 from "./TabelaDinamicaDashboardLaudos.vue?vue&type=style&index=0&id=4efdd42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efdd42a",
  null
  
)

export default component.exports